<template>
	<div>
		<vxe-modal v-model="show" width="400" title="拉取配置" show-footer @confirm="submitPrice">
			<template #default>
				<el-form ref="form" :model="pullForm" label-width="100px" size="mini">
					<el-form-item label="页码">
						<el-input-number v-model="pullForm.page" :min="1" controls-position="right"></el-input-number>
					</el-form-item>
					<el-form-item label="数量">
						<el-input-number v-model="pullForm.limit" :min="10" controls-position="right"></el-input-number>
					</el-form-item>
					<el-form-item label="线上更新日期">
						<el-date-picker v-model="pullForm.date" type="date" value-format="timestamp">
						</el-date-picker>
					</el-form-item>
				</el-form>
			</template>
		</vxe-modal>
	</div>
</template>
<style>

</style>
<style scoped>

</style>
<script>
	export default {
		name: 'goodspriceIndex',
		props: {
			pullForm: {
				type: Object,
				default: () => {
					return {
						date: Date.parse(new Date()),
						page: 1,
						limit: 100,
					}
				}
			},
		},
		data() {
			return {
				show: false,
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			submitPrice() {
				this.$emit('submit', {
					data: this.priceForm
				})
			}
		},
		components: {

		}
	}
</script>
